<template>
    <Tabs
        v-gtm:type="'SportList'"
        class="wrapper"
        v-bind:enableCollapse="false"
    >
        <Tab
            name="sports"
            v-bind:label="i18n.t('tab_title_sports')"
            sboIcon="product:sports"
            iconSize="18"
        />
        <template #sports>
            <SportList
                v-bind:items="sportList"
            />
        </template>
    </Tabs>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import SportList from '@/components/sportList/SportList.Euro.vue';
    import Tab from '@/components/tabs/Tab.vue';
    import Tabs from '@/components/tabs/Tabs.vue';
    import { i18n } from '@/core/lib/i18n';
    import { useEuroSideBarStore } from '@/store/sideBarStore.Euro';

    const { sportList } = storeToRefs(useEuroSideBarStore());
</script>

<style lang="scss" scoped>
    @import "@/components/sportList/SportListBlock.Euro";
</style>
